'use strict';

module.exports = function sign(number) {
	return number >= 0 ? 1 : -1;
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/es-abstract/helpers/sign.js
 ** module id = 2901
 ** module chunks = 0
 **/